import { createRoute } from '@tanstack/react-router';
import { loginParentRoute } from 'pages/shared/Login/loginParentRoute';

export const loginCodeRoute = createRoute({
  getParentRoute: () => loginParentRoute,
  path: '/code',
}).lazy(() => import('pages/shared/Login/VerifyCode/VerifyCode').then((d) => d.Route));
